<template>
  <div class="course_container">
    <div class="tab_wrap">
      <div class="change-child" v-if="userType == 'PARENT'">
        <span class="name-drp">当前儿童：</span>
        <div class="name-warp" @click="showAllChild">
          <span class="name">
            {{
              (children.find((item) => item.id == selectId) || {}).studentName
            }}
          </span>
          <img
            src="../../assets/images/parent-course/rigth-arrow-big.png"
            class="right-arrow"
            alt="向右展开箭头"
          />
        </div>
      </div>
      <ul class="change-tab">
        <router-link :to="{ path: '/course' }">
          <li class="health-education-active">
            <span>迪夫学院</span>
          </li>
        </router-link>
        <router-link :to="{ path: '/testCenter' }">
          <li class="assess">
            <span>筛查及考核</span>
          </li>
        </router-link>
      </ul>
    </div>
    <div class="van-tabs-warp" :class="{ is_fixed: isFixed }">
      <loading v-if="loadings"></loading>
      <van-tabs
        v-if="!loadings"
        @click="tabClick"
        swipe-threshold="1"
        title-active-color="#fff"
        v-model="tabValue"
        title-inactive-color="#ff8340"
        ref="tab1"
      >
        <van-tab
          v-for="(item, index) in tabTitle"
          :key="index"
          :title="item"
        ></van-tab>
      </van-tabs>
      <div class="moreBox" @click="showMore">
        <img
          src="../../assets/images/parent-course/more.png"
          class="more"
          alt=""
        />
        <p>全部</p>
      </div>
    </div>
    <!-- 视频、文章内容区域 -->
    <div class="content_area">
      <div class="content_tab" :class="{ is_fixed_2: isFixed }">
        <van-tabs
          @click="tabContentClick"
          v-model="tabContentValue"
          title-active-color="#3B3B3B"
          title-inactive-color="#626A6B"
          background="transparent"
          v-if="showNextTab && !isOutLine"
          ref="tab2"
        >
          <van-tab
            v-for="item in tabContentTitle"
            :key="item.id"
            :title="item.type"
          ></van-tab>
        </van-tabs>
        <!--        课程tag-->
        <van-tabs
          class="tag-tab-class"
          @click="tagTabClick"
          v-model="tagTabValue"
          title-active-color="#3B3B3B"
          title-inactive-color="#626A6B"
          background="transparent"
          v-if="showTagTab"
        >
          <van-tab
            v-for="item in tagTabList"
            :key="item.id"
            :title="item.title"
          ></van-tab>
        </van-tabs>
      </div>
      <div class="conent_detail" :style="{ 'margin-top': skuWarpMarginTop }">
        <van-list
          v-show="showSecondContent"
          ref="listContent"
          v-model="loading"
          :finished="finished"
          :immediate-check="true"
          :finished-text="finishText"
          @load="loadMore"
        >
          <second-step
            :showVideoPng="showVideoPng"
            :isOutLine="isOutLine"
            :contentList="contentList"
            :showContent="showSecondContent"
          />
        </van-list>
        <first-step
          :branchList="branchList"
          :showFirstContent="!showSecondContent && !loadingOther"
        />
        <loading v-if="loadingOther" style="margin-top: 120px"></loading>
        <no-datas
          :class="{ marginStyle: !showNextTab }"
          :dataExit="dataExit"
          :isCourse="isCourse"
        />
      </div>
    </div>
    <!-- 弹框区 -->
    <div class="pop_up">
      <modal-popup
        ref="pop"
        :contentTitle="acContentTile"
        :contentText="acContentText"
      />
      <modal
        ref="testPop"
        btnType="1"
        sureText="知道了"
        @cancel="closeFn"
        @submit="goCenter"
      >
        <template v-slot:body>
          <p>当前有未完成的问卷哦，快去检查吧</p>
        </template>
      </modal>
    </div>

    <van-popup v-model="showTop" round position="top" class="modalBox">
      <div class="topModal">
        <div class="topModal-title">
          <p>栏目</p>
          <img
            src="../../assets/images/parent-course/close.png"
            @click="topModalClose"
            alt=""
          />
        </div>
        <div class="topModal-content">
          <div
            v-for="(item, index) in tabTitle"
            :key="index"
            class="topModal-content-title"
            :class="{ chooseActive: tabValue == index }"
            @click="chooseColumn(index, item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </van-popup>

    <van-overlay
      :show="showAllChildOverlay"
      z-index="5"
      @click="showAllChildOverlay = false"
    >
      <div class="namelist-warp" @click.stop>
        <div>请选择当前儿童</div>
        <div
          class="namelist-item"
          :class="{ 'namelist-item-active': index == selectIndex }"
          v-for="(item, index) in children"
          :key="item.id"
          @click="selectIndex = index"
        >
          {{ item.studentName }}
        </div>
        <van-button
          color="rgba(14, 215, 225, 0.20)"
          text="确定"
          round
          @click="sureChild"
        ></van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { acContentTile, acContentText } from "../../common/commonData/index.js";
import SecondStep from "../../components/parent-course/second-step.vue";
import FirstStep from "../../components/parent-course/first-step.vue";
import ModalPopup from "../../components/parent-course/modal-popup.vue";
import {
  _getCourseList,
  _getColumnLayer,
  _getColumnBranch,
  _getUserConcerned,
  _queryIsPayed,
  _existContents,
  _getColumnContents,
} from "../../api/parent-course";
import EmptyData from "../../components/parent-course/empty-data.vue";
import { Toast } from "vant";
import { getRequest, getRequestNoBaseUrl } from "../../assets/js/api";
import NoDatas from "../../components/common/no-datas.vue";
import { verticalScreen } from "../../assets/js/vertical-screen";
import Loading from "@/components/common/is-loading";
import { _paperNum } from "../../api/test-center";
import { decryptBy, encryptBy } from "@/assets/js/encryption";
import { _queryArchives } from "../../api/family-archives";
import Modal from "../../components/common/modal.vue";
import { landType } from "@/common/utils/utils";
import { setOpenId, registerWxConfig } from "@/weixinConfig";
export default {
  inject: ["reload"],
  name: "parent-course",
  components: {
    SecondStep,
    ModalPopup,
    FirstStep,
    EmptyData,
    NoDatas,
    Loading,
    Modal,
  },
  props: {},
  data() {
    return {
      // 公共固定数据
      acContentTile,
      acContentText,

      // 切换儿童相关
      showAllChildOverlay: false,
      selectIndex: 0,

      userInfo: {},
      totalPaperNum: 0,
      loadingOther: false,
      loadings: false,
      finishText: "没有数据了哦！",
      loadMoreFlag: true, //是否加载了一次
      finished: false, //加载状态
      loading: false,
      showFirstContent: false, //一级文章列表展示
      // showSecondContent:true,//展示视频文章列表
      tabContentTitle: [
        { type: "视频", id: "110", status: false },
        { type: "文章", id: "111", status: false },
      ],
      tabTitle: [],
      tabValue: JSON.parse(sessionStorage.getItem("tabValue")) || 1, //tab栏目菜单切换值 收藏 推荐 精选等
      tabContentValue: JSON.parse(sessionStorage.getItem("tabChangeMain")) || 0, //tab栏目菜单切换值 文章 视频

      // 请求收藏文章的接口参数
      concernParams: {
        asc: false,
        currentPage: 0,
        pageSize: 5, //每页多少条
        queryData: {
          contentType: "VIDEO",
        },
      },
      // 精选 推荐
      contentParams: {
        asc: false,
        currentPage: 0,
        pageSize: 5, //每页多少条
        queryData: {
          handpick: false,
          tag: "家长",
          top: false,
          recommend: true,
          contentTypeList: ["VIDEO"],
          studentId: "",
        },
      },
      // 购买
      isPayedParams: {
        asc: false,
        currentPage: 0,
        pageSize: 5,
        queryData: {
          contentType: "VIDEO",
          putaway: false,
        },
      },
      // 根据栏目id获取文章视频
      contentParamsOther: {
        asc: false,
        currentPage: 0,
        pageSize: 5,
        queryData: {
          columnId: "",
          contentType: "VIDEO",
          putaway: true,
          tag: "家长",
        },
      },

      // 判断栏目下是否有视频文章或者层级关系
      existParams: {
        columnId: "",
      },

      // 获取栏目下的视频或者文章内容或者层级关系
      deailParams: {
        code: "JZ",
        columnId: "",
      },
      //分级菜单列表的参数
      layerParams: {
        columnLayer: "一级栏目",
        page: 1, //当前页
        limit: 100, //每页多少条
        source: 1,
      },
      contentList: [], //内容精选文章 视频数据
      layerList: [], //一级栏目的数据
      layerRecord: [], //一栏栏目所有的未经处理的数据
      branchList: [], //首页一级维度的数据
      tagTabList: [], //课程分类数据
      tagTabValue: 0, //当前选中的数据
      dataExit: false,
      flag1: true,
      isFirstLogin: false,
      isFixed: false,
      scrollTops: 0,
      showtab: false, //是否展示文章/视频tab
      temArticalArr: [],
      temArVideoArr: [],
      firstLayer: false,
      userType: "",
      showTop: false, //顶部弹窗
      isOutLine: false,
      DefaultTabEnum: {
        //枚举
        Recommend: "推荐",
        Collection: "收藏",
        Purchased: "已购买",
        Selected: "精选",
      },
      defaultTabList: [], //默认显示的tab "推荐", "收藏", "已购买", "精选"
      noContentTabList: [
        "线下课程",
        "线下实操课程",
        "线上视频课程",
        "公众号科普文章",
        "儿童发育行为对照表",
      ], //不显示视频、文章tab的标签
      showTagTabList: ["线上视频课程", "公众号科普文章"], //展示课程标签tag 运动方面、语言方面、作业方面、心理方面等
    };
  },
  watch: {
    selectId: {
      handler(newval) {
        if (newval) {
          this.contentParams.queryData.studentId = newval;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    verticalScreen();
    localStorage.removeItem("paymentShowVideoPng");
  },
  computed: {
    isCourse() {
      return this.tabTitle[this.tabValue] === this.DefaultTabEnum.Purchased;
    },

    children() {
      return this.$store.state.children;
    },
    selectId() {
      return this.$store.state.childId;
    },

    // 收藏 推荐 精选一级tab模式下，直接出现文章视频tab
    showNextTab() {
      let { tabValue, tabTitle } = this;
      if (
        this.defaultTabList.includes(tabTitle[tabValue]) ||
        (this.showtab && !this.noContentTabList.includes(tabTitle[tabValue]))
      )
        return true;
      return false;
    },
    //展示课程标签tag 运动方面、语言方面、作业方面、心理方面等
    showTagTab() {
      let { showTagTabList, tabValue, tabTitle } = this;
      if (showTagTabList.includes(tabTitle[tabValue])) return true;
      return false;
    },
    //收藏 推荐 精选文章的结构
    showSecondContent: {
      get() {
        let { tabValue, tabTitle } = this;
        if (this.defaultTabList.includes(tabTitle[tabValue]) || this.showtab)
          return true;
        return false;
      },
      set() {},
    },
    showVideoPng() {
      //是否显示数据中vide.png图标
      // let { tabContentValue } = this;
      // let val = tabContentValue === 0 ? true : false;
      // return val;
      return false;
    },

    skuWarpMarginTop() {
      if (this.isFixed) {
        return (
          this.skuWarpMarginTopNmu +
          parseFloat(this.OriginskuWarpMarginTopNmu.replace("px", "")) -
          16 +
          "px"
        );
      } else {
        return this.OriginskuWarpMarginTopNmu;
      }
    },
  },
  methods: {
    showAllChild() {
      this.showAllChildOverlay = true;
      this.selectIndex = this.children.findIndex(
        (item) => item.id == this.selectId
      );
    },
    sureChild() {
      this.$store.commit("CHILDID", this.children[this.selectIndex].id);
      this.$emit("selectChild", this.selectId);
      this.showAllChildOverlay = false;
      //隐藏精选了
      // if (this.tabValue == 0 || this.tabValue == this.tabTitle.length - 1) {
      if (this.tabValue == 0) {
        const val = sessionStorage.getItem("tabValue") - 0;
        this.tabClick(val);
      }
    },

    goCenter() {
      this.$router.push("/testCenter");
      sessionStorage.setItem("firstTip", 1);
    },
    closeFn() {
      sessionStorage.setItem("firstTip", 1);
      this.$refs.testPop.closeDialog();
    },
    // 查询家长信息
    async queryArchives() {
      try {
        let res = await _queryArchives();
        let { code, message, data } = res;
        if (res && code === 200) {
          this.userInfo = data;
          localStorage.setItem("parentsInfor", encryptBy(JSON.stringify(data)));
        } else {
          Toast(message);
        }
      } catch (error) {}
    },
    initFixedHeight() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isFixed = scrollTop > this.limiNum ? true : false;
    },
    //点击栏目更多
    showMore() {
      this.showTop = true;
    },
    //关闭栏目弹窗
    topModalClose() {
      this.showTop = false;
    },
    //栏目弹窗选择栏目
    chooseColumn(index, val) {
      this.showTop = false;
      this.tabValue = index;
      this.tabClick(this.tabValue, val);
    },
    // tab栏目菜单切换 收藏 推荐 精选等
    tabClick(val, e) {
      let labelIds = this.layerRecord.find((val) => val.name == e);
      if (labelIds) {
        localStorage.setItem("labelIds", labelIds.id);
      } else {
        localStorage.setItem("labelIds", "");
      }
      // 用户点击了一级，那么下方的如果有文章视频切换，默认展示视频
      sessionStorage.setItem("tabChangeMain", 0);
      this.tabContentValue = 0;
      // 视频，对应的type为video，文章对应artical
      //这些栏目下不显示视频/文章，传参需要修改为传值全部
      if (this.noContentTabList.includes(this.tabTitle[val])) {
        //用户点击了一级tab，重置下方有数据的tab视频/文章为video视频
        this.concernParams.queryData.contentType = "VIDEO,PICTURE,FILE";
        this.contentParams.queryData.contentTypeList = ["VIDEO,PICTURE,FILE"];
        this.contentParamsOther.queryData.contentType = "VIDEO,PICTURE,FILE";
        this.isPayedParams.queryData.contentType = "VIDEO,PICTURE,FILE";
      } else {
        if (this.tabContentValue == 0) {
          //用户点击了一级tab，重置下方有数据的tab视频/文章为video视频
          this.concernParams.queryData.contentType = "VIDEO";
          this.contentParams.queryData.contentTypeList = ["VIDEO"];
          this.contentParamsOther.queryData.contentType = "VIDEO";
          this.isPayedParams.queryData.contentType = "VIDEO";
        }
      }
      this.dataExit = false;
      this.$bus.$emit("tabChange", val);
      // 存储tab的点击当前val
      sessionStorage.setItem("tabValue", val);
      // e为点击的name名字，比如：社交问题等
      // 重要！！！！ 需要重置加载状态
      this.resetTabFn();
      this.contentList = [];
      this.tabValue = val;
      //重置tab为视频
      this.resetVideoTab();
      //点击tab，默认请求视频
      if (this.tabTitle[this.tabValue] === this.DefaultTabEnum.Collection) {
        //收藏模块
        // this.dataExit = false
        this.resetTabFn();
        this.concernParams.currentPage = 0;
        this.contentParams.currentPage = 0;
        this.contentParamsOther.currentPage = 0;
        this.isPayedParams.currentPage = 0;
        this.conmonFn1();
      } else if (this.tabValue === 0) {
        //推荐模块
        // this.dataExit = false
        // 推荐-视频-请求数据
        this.resetTabFn();
        this.concernParams.currentPage = 0;
        this.contentParams.currentPage = 0;
        this.contentParamsOther.currentPage = 0;
        this.isPayedParams.currentPage = 0;
        this.conmonFn2();
        /*} else if (this.tabValue === this.tabTitle.length - 1) {
        //精选模块
        this.resetTabFn();
        this.concernParams.currentPage = 0;
        this.contentParams.currentPage = 0;
        this.contentParamsOther.currentPage = 0;
        this.isPayedParams.currentPage = 0;
        // this.dataExit = false
        // 精选-视频-请求数据
        this.conmonFn3();*/
      } else if (
        this.tabTitle[this.tabValue] === this.DefaultTabEnum.Purchased
      ) {
        this.resetTabFn();
        this.concernParams.currentPage = 0;
        this.contentParams.currentPage = 0;
        this.contentParamsOther.currentPage = 0;
        this.isPayedParams.currentPage = 0;
        this.conmonFn4();
      } else {
        // 该处为当栏目下面有视频文章的时候
        this.contentParamsOther.currentPage = 0;
      }
      this.findId(val, e);
    },
    // tab重置
    resetTabFn() {
      this.loading = false;
      this.finished = false;
      this.$refs.listContent.check();
    },
    // 文章 视频 tab切换
    tabContentClick(val) {
      // 记录点击的选项 0视频，1文章
      sessionStorage.setItem("tabChangeMain", val);
      this.concernParams.currentPage = 0;
      this.contentParams.currentPage = 0;
      this.contentParamsOther.currentPage = 0;
      this.isPayedParams.currentPage = 0;
      // 重复点击本身的时候，不可以点击
      this.resetTabFn();
      //  清空数据
      this.contentList = [];
      if (this.tabTitle[this.tabValue] === this.DefaultTabEnum.Collection) {
        // 收藏模块
        if (this.tabContentValue === 0) {
          this.resetTabFn();
          this.conmonFn1();
          this.concernParams.queryData.contentType = "VIDEO";
        } else if (this.tabContentValue === 1) {
          this.resetTabFn();
          // 收藏-文章-请求数据
          this.concernParams.queryData.contentType = "PICTURE,FILE";
        }
      } else if (this.tabValue === 0) {
        //推荐模块
        if (this.tabContentValue === 0) {
          this.resetTabFn();
          this.conmonFn2();
          this.changeArrParams("VIDEO");
        } else if (this.tabContentValue === 1) {
          this.resetTabFn();
          // 推荐-文章-请求数据
          this.changeBol(false, true, false);
          this.changeArrParams("PICTURE,FILE");
          // this.getCourseList(this.contentParams)
        }
        /*} else if (this.tabValue === this.tabTitle.length - 1) {
        //精选模块
        if (this.tabContentValue === 0) {
          this.resetTabFn();
          this.conmonFn3();
          this.changeArrParams("VIDEO");
        } else if (this.tabContentValue === 1) {
          this.resetTabFn();
          // 精选-文章-请求数据
          this.changeBol(false, false, true);
          this.changeArrParams("PICTURE,FILE");
          // this.getCourseList(this.contentParams)
        }*/
      } else if (
        this.tabTitle[this.tabValue] === this.DefaultTabEnum.Purchased
      ) {
        if (this.tabContentValue === 0) {
          this.resetTabFn();
          this.conmonFn4();
          this.isPayedParams.queryData.contentType = "VIDEO";
        } else if (this.tabContentValue === 1) {
          this.resetTabFn();
          // 收藏-文章-请求数据
          this.isPayedParams.queryData.contentType = "PICTURE,FILE";
        }
      } else {
        // 文章视频切换，此处为当栏目下面有视频或者文章的时候进行切换
        if (this.tabContentValue == 0 || !this.tabContentValue) {
          this.resetTabFn();
          // 视频
          this.contentParamsOther.queryData.contentType = "VIDEO";
          // this.getColumnContents(this.contentParamsOther)
        } else {
          this.resetTabFn();
          // // 文章
          this.contentParamsOther.queryData.contentType = "PICTURE,FILE";
          // this.getColumnContents(this.contentParamsOther)
        }
      }
    },
    //课程标签点击事件
    tagTabClick(val) {
      //  清空数据
      this.contentList = [];
      let label = this.tagTabList[val].value;
      this.contentParamsOther.currentPage = 0;
      this.contentParamsOther.queryData.label = label;
      this.resetTabFn();
    },
    //改变收藏 推荐 精选的请求的参数
    changeBol(val1, val2, val3) {
      this.contentParams.queryData.top = val1;
      this.contentParams.queryData.recommend = val2;
      this.contentParams.queryData.handpick = val3;
    },
    //参数文章视频类型切换
    changeArrParams(val) {
      this.contentParams.queryData.contentTypeList = [];
      this.contentParams.queryData.contentTypeList.push(val);
    },
    // 收藏-视频-请求数据
    conmonFn1() {
      this.contentParams.currentPage = 0;
      this.concernParams.queryData.contentType = "VIDEO";
    },
    // 推荐-视频-请求数据
    conmonFn2() {
      this.changeBol(false, true, false);
      this.changeArrParams("VIDEO");
      this.contentParams.currentPage = 0;
    },
    // 精选-视频-请求数据
    conmonFn3() {
      this.changeBol(false, false, true);
      this.changeArrParams("VIDEO");
      this.contentParams.currentPage = 0;
    },

    // 精选-视频-请求数据
    conmonFn4() {
      this.isPayedParams.currentPage = 0;
      this.concernParams.queryData.contentType = "VIDEO";
    },

    // 重置为视频tab
    resetVideoTab() {
      this.tabContentValue = 0;
    },
    // 加载更多视频文章 attention:不需要手动触发，会自动执行
    loadMore() {
      // 当前栏目下面有文章视频数据
      let { contentParamsOther } = this;
      let { contentParams } = this;
      let { concernParams } = this;
      let { isPayedParams } = this;
      contentParams.currentPage += 1;
      concernParams.currentPage += 1;
      contentParamsOther.currentPage += 1;
      isPayedParams.currentPage += 1;
      // 如果tab视频 文章切换了，返回到首页的时候默认为上次切换的主题
      let tabStatus = JSON.parse(sessionStorage.getItem("tabChangeMain")) || 0; //默认0视频
      // 首先，确认当前的一级tab是哪个
      let tabAck = JSON.parse(sessionStorage.getItem("tabValue")); //默认1推荐
      if (tabAck == 0 || tabAck == undefined || tabAck == null) {
        //推荐模块
        // 判断参数
        contentParams.queryData.recommend = true;
        contentParams.queryData.handpick = false;
        if (tabStatus == 0 || !tabStatus) {
          // 上次点击的是视频
          this.tabContentValue = 0;
          contentParams.queryData.contentTypeList = ["VIDEO"];
        } else {
          // 上次点击的是文章
          this.tabContentValue = 1;
          let { contentParams } = this;
          contentParams.queryData.contentTypeList = ["PICTURE", "FILE"];
        }
        this.getCourseList(contentParams);
        /*} else if (tabAck == this.tabTitle.length - 1) {
        //精选
        let { contentParams } = this;
        contentParams.queryData.recommend = false;
        contentParams.queryData.handpick = true;
        if (tabStatus == 0 || !tabStatus) {
          // 上次点击的是视频
          this.tabContentValue = 0;
          contentParams.queryData.contentTypeList = ["VIDEO"];
        } else {
          // 上次点击的是文章
          this.tabContentValue = 1;
          let { contentParams } = this;
          contentParams.queryData.contentTypeList = ["PICTURE", "FILE"];
        }
        this.getCourseList(contentParams);*/
      } else if (this.tabTitle[tabAck] == this.DefaultTabEnum.Collection) {
        //关注的模块
        // 判断点击收藏的时候是否进行了文章视频的tab切换操作
        if (tabStatus == 0 || !tabStatus) {
          // 上次点击的是视频
          this.tabContentValue = 0;
          let { concernParams } = this;
          concernParams.queryData.contentType = "VIDEO";
        } else {
          // 上次点击的是文章
          this.tabContentValue = 1;
          let { concernParams } = this;
          concernParams.queryData.contentType = "PICTURE,FILE";
        }
        this.getUserConcerned(concernParams);
      } else if (this.tabTitle[tabAck] === this.DefaultTabEnum.Purchased) {
        // 判断点击的时候是否进行了文章视频的tab切换操作
        if (tabStatus == 0 || !tabStatus) {
          // 上次点击的是视频
          this.tabContentValue = 0;
          let { isPayedParams } = this;
          isPayedParams.queryData.contentType = "VIDEO";
        } else {
          // 上次点击的是文章
          this.tabContentValue = 1;
          let { isPayedParams } = this;
          isPayedParams.queryData.contentType = "PICTURE,FILE";
        }
        this._queryIsPayed(isPayedParams);
      } else {
        this.getColumnContents(contentParamsOther);
      }
    },
    findId(val, e) {
      this.isOutLine = e == "线下课程" ? true : false;
      let eNameObj = this.layerRecord.find((val) => val.name == e);
      if (this.defaultTabList.includes(e)) {
        localStorage.setItem("colu", e);
      } else {
        localStorage.setItem("colu", "");
        // 保存当前栏目的id，nextVideo中需要使用栏目id入参
        if (eNameObj && eNameObj.id) {
          localStorage.setItem("columnId", JSON.stringify(eNameObj.id));
        }
      }
      if (eNameObj) {
        // this.getColumnBranch(eNameObj.id)
        // 更新接口，可以获取文章或者视频或者层级关系
        this.existParams.columnId = eNameObj.id + "";
        // id赋值在这里是因为放到了ajax中有时候会被覆盖
        this.contentParamsOther.queryData.columnId = eNameObj.id + ""; //一会儿写注释
        this.existContents(this.existParams);
      }

      let tempObj = {};
      if (eNameObj && eNameObj.id) {
        tempObj.value = val;
        tempObj.id = eNameObj.id;
        tempObj.e = e;
      } else {
        tempObj.value = val;
        tempObj.id = "";
      }
      // 存储的信息为非收藏 推荐 精选的tab信息，包含id和当前的val值
      sessionStorage.setItem("tabInfoDetail", JSON.stringify(tempObj));
    },
    // 获取推荐和精选的数据
    async getCourseList(contentParams) {
      try {
        let res = await _getCourseList(contentParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          //加载状态结束
          this.loading = false;
          // 合并第一次和第N次请求的书
          this.contentList = this.contentList.concat(data.records);
          if (contentParams.currentPage >= data.pages) {
            this.finished = true;
          }
          //当数据全部加载完成
          if (data.records.length == 0) {
            this.finished = true;
          }
          if (this.contentList.length === 0) {
            // 添加缺省图
            this.showSecondContent = false;
            this.dataExit = true;
            this.finishText = "";
          } else {
            this.showSecondContent = true;
            this.dataExit = false;
            this.finishText = "没有数据了哦！";
          }
        } else {
          this.loading = false;
          this.finished = true;
          // this.error = true
          Toast(message);
        }
      } catch (error) {}
    },
    //获取一级
    async getColumnsLayer(layerParams) {
      this.loadings = true;
      // 请求前先处预设值为初始数据    "推荐", "收藏", "已购买", "精选"
      this.tabTitle = [...this.defaultTabList];
      try {
        let res = await _getColumnLayer(layerParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          this.loadings = false;
          this.layerRecord = data.records;
          let tempArr = data.records;
          if (tempArr && tempArr.length > 0) {
            let arr = [];
            tempArr.forEach((item) => {
              arr.push(item.name);
            });
            this.tabTitle.splice(1, 0, ...arr);
          } else {
            this.layerRecord = [];
            this.tabTitle = [...this.defaultTabList];
          }
        } else {
          this.loadings = false;
          this.layerRecord = [];
          this.tabTitle = [...this.defaultTabList];
          Toast(message);
        }
        sessionStorage.setItem("tabTitlelen", this.tabTitle.length);
      } catch (error) {
        this.loadings = false;
      }
    },
    // 根据id获取栏目下的内容
    async getColumnBranch(id) {
      this.loadingOther = true;
      try {
        getRequest(`/api-content/column/branches/` + id + "?code=JZ").then(
          (res) => {
            this.loadingOther = false;
            let { code, message, data } = res;
            if (res && code === 200) {
              if (data && data.length > 0) {
                this.dataExit = false;
                this.branchList = data;
              } else {
                // 没数据，缺省图
                this.dataExit = true;
                this.branchList = [];
              }
            } else {
              this.loadingOther = false;
              this.branchList = [];
              this.dataExit = true;
              // 没数据，缺省图
              Toast(message);
            }
          }
        );
      } catch (error) {
        this.loadingOther = false;
      }
    },
    // 获取user收藏的内容
    async getUserConcerned(concernParams) {
      try {
        let res = await _getUserConcerned(concernParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          //加载状态结束
          this.loading = false;
          // 合并第一次和第N次请求的书
          this.contentList = this.contentList.concat(data.records);
          //当数据全部加载完成
          if (data.records.length == 0) {
            this.finished = true;
          }
          if (this.contentList.length === 0) {
            // 添加缺省图
            this.showSecondContent = false;
            this.dataExit = true;
            this.finishText = "";
          } else {
            this.showSecondContent = true;
            this.dataExit = false;
            this.finishText = "没有数据了哦！";
          }
        } else {
          this.loading = false;
          this.finished = true;
          // this.error = true
          Toast(message);
        }
      } catch (error) {
        this.loading = false;
      }
    },
    async _queryIsPayed(isPayedParams) {
      try {
        let res = await _queryIsPayed(isPayedParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          //加载状态结束
          this.loading = false;
          // 合并第一次和第N次请求的书
          this.contentList = this.contentList.concat(data.records);
          //当数据全部加载完成
          if (data.records.length == 0) {
            this.finished = true;
          }
          if (this.contentList.length === 0) {
            // 添加缺省图
            this.showSecondContent = false;
            this.dataExit = true;
            this.finishText = "";
          } else {
            this.showSecondContent = true;
            this.dataExit = false;
            this.finishText = "没有数据了哦！";
          }
        } else {
          this.loading = false;
          this.finished = true;
          // this.error = true
          Toast(message);
        }
      } catch (error) {
        this.loading = false;
      }
    },

    // 判断当前栏目下的内容种类，是有文章/视频或者层级关系
    existContents(existParams) {
      this.contentParamsOther.currentPage = 0;
      try {
        getRequest(
          "/api-content/column/exist/contents?columnId=" + existParams.columnId
        ).then(async (res) => {
          let { code, data, message } = res;
          if (res && code === 200) {
            // 如果data为true，有视频或者文章，fasle就没有视频或者文章
            // 有视频文章，就显示tab，并且可以进行切换
            if (data) {
              this.showtab = true;
              // this.contentParamsOther.queryData.columnId = existParams.columnId
              this.contentParamsOther.currentPage += 1;
              await this.getColumnContents(this.contentParamsOther);
            } else {
              this.showtab = false;
              // 没有视频和文章，就调用获取栏目层级的接口 cyccyc
              this.getColumnBranch(this.existParams.columnId);
            }
          } else {
            Toast(message);
          }
        });
      } catch (error) {}
    },
    // 根据id获取栏目下的内容
    async getColumnContents(contentParams) {
      try {
        if (this.isOutLine) {
          contentParams.queryData.contentType = "";
          contentParams.queryData.courseType = "2";
        } else {
          delete contentParams.queryData.courseType;
        }
        let res = await _getColumnContents(contentParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          //加载状态结束
          this.loading = false;
          // 合并第一次和第N次请求的书
          this.contentList = this.contentList.concat(data.records);
          if (contentParams.currentPage >= data.pages) {
            this.finished = true;
          }
          //当数据全部加载完成
          if (data.records.length == 0) {
            this.finished = true;
          }
          if (this.contentList.length === 0) {
            // 添加缺省图
            this.showSecondContent = false;
            this.dataExit = true;
            this.finishText = "";
          } else {
            this.showSecondContent = true;
            this.dataExit = false;
            this.finishText = "没有数据了哦！";
          }
        } else {
          this.loading = false;
          this.finished = true;
          // this.error = true
          Toast(message);
        }
      } catch (error) {}
    },
    //获取课程分类
    getTagList() {
      getRequestNoBaseUrl(
        "/business/api/api-common/dict-item/invoke/list?code=content_tag"
      ).then(async (res) => {
        let { code, data, message } = res;
        if (res && code === 200) {
          let temp = data?.map((item) => ({
            title: item.name,
            value: item.name,
          }));
          this.tagTabList = [{ title: "全部", value: "" }, ...temp];
        }
      });
    },
    // 如托卡通导航弹框，当前页面是首页，进入到收藏，进入到收藏列表
    initFF() {
      this.$bus.$on("toConcerned", (val) => {
        if (val === 0) {
          // 0代表收藏的tab
          this.tabClick(this.tabTitle.indexOf(this.DefaultTabEnum.Collection));
        }
        if (val === 1) {
          // 0代表收藏的tab
          this.tabClick(0);
        }
      });
    },
    initInfo() {
      // if (decryptBy(localStorage.getItem('children')) != 'null') {
      //   this.children = JSON.parse(decryptBy(localStorage.getItem('children')))
      //   this.selectId = this.children[0].id
      // }
      // this.queryArchives()
    },
  },
  beforeCreate() {},
  async created() {
    // if (!sessionStorage.getItem("openid")) {
    //   registerWxConfig();
    // }
    this.defaultTabList = [
      this.DefaultTabEnum.Recommend,
      this.DefaultTabEnum.Collection,
      this.DefaultTabEnum.Purchased,
    ];
    this.initInfo();
    let info = localStorage.getItem("userInfo");
    let user = JSON.parse(decryptBy(info));
    if (user) {
      this.userType = user.userType;
    }
    //获取课程分类
    this.getTagList();
    await this.getColumnsLayer(this.layerParams);
    // 如果tab视频 文章切换了，返回到首页的时候默认为上次切换的主题
    let tabStatus = JSON.parse(sessionStorage.getItem("tabChangeMain"));
    // 一级栏目下点击的事件
    // let tabValue = JSON.parse(sessionStorage.getItem('tabValue'))
    // 首先，确认当前的一级tab是哪个
    let tabAck = JSON.parse(sessionStorage.getItem("tabValue"));
    // 如果tabAck 为0 1 2 ，对应的是收藏 推荐 其他 否则为其他栏目 tabValue
    //因为把收藏，已购买，精选放到最后三位
    if (this.tabTitle[tabAck] == this.DefaultTabEnum.Collection) {
      //收藏模块
      this.tabValue = tabAck;
      // 判断点击收藏的时候是否进行了文章视频的tab切换操作
      if (tabStatus == 0 || !tabStatus) {
        // 上次点击的是视频
        this.tabContentValue = 0;
        let { concernParams } = this;
        concernParams.queryData.contentType = "VIDEO";
        // 请求收藏的数据接口
      } else {
        // 上次点击的是文章
        this.tabContentValue = 1;
        let { concernParams } = this;
        concernParams.queryData.contentType = "PICTURE,FILE";
        // 请求收藏的数据接口
      }
      this.getUserConcerned(concernParams);
    } else if (tabAck == 0 || !tabAck) {
      //推荐模块
      let { contentParams } = this;
      contentParams.queryData.recommend = true;
      contentParams.queryData.handpick = false;
      this.tabValue = 0;
      if (tabStatus == 0 || !tabStatus) {
        // 上次点击的是视频
        this.tabContentValue = 0;
        contentParams.queryData.contentTypeList = ["VIDEO"];
        // this.getCourseList(contentParams)
      } else {
        // 上次点击的是文章
        this.tabContentValue = 1;
        let { contentParams } = this;
        contentParams.queryData.contentTypeList = ["PICTURE", "FILE"];
        // this.getCourseList(contentParams)
      }
      /*} else if (tabAck == this.tabTitle.length - 1) {
      //精选模块
      this.tabValue = tabAck;
      let { contentParams } = this;
      contentParams.queryData.recommend = false;
      contentParams.queryData.handpick = true;
      if (tabStatus == 0 || !tabStatus) {
        // 上次点击的是视频
        this.tabContentValue = 0;
        contentParams.queryData.contentTypeList = ["VIDEO"];
        // this.getCourseList(contentParams)
      } else {
        // 上次点击的是文章
        this.tabContentValue = 1;
        let { contentParams } = this;
        contentParams.queryData.contentTypeList = ["PICTURE", "FILE"];
        // this.getCourseList(contentParams)
      }
      this.getCourseList(contentParams);*/
    } else if (this.tabTitle[tabAck] === this.DefaultTabEnum.Purchased) {
      this.tabValue = tabAck;
      let { isPayedParams } = this;
      // 判断点击收藏的时候是否进行了文章视频的tab切换操作
      if (tabStatus == 0 || !tabStatus) {
        // 上次点击的是视频
        this.tabContentValue = 0;
        isPayedParams.queryData.contentType = "VIDEO";
        // 请求收藏的数据接口
      } else {
        // 上次点击的是文章
        this.tabContentValue = 1;
        isPayedParams.queryData.contentType = "PICTURE,FILE";
        // 请求收藏的数据接口
      }
      isPayedParams.currentPage = 1;
      this._queryIsPayed(isPayedParams);
    } else {
      //非前三种模块，此时需要重新请求数据
      let tempInfo = JSON.parse(sessionStorage.getItem("tabInfoDetail"));
      this.tabValue = tempInfo.value;
      let tempMain = JSON.parse(sessionStorage.getItem("tabChangeMain"));
      // 改变参数是视频还是文章，三级中需要
      if (tempMain == 0 || !tempMain) {
        //视频
        this.contentParamsOther.queryData.contentType = "VIDEO";
        this.contentParamsOther.currentPage = 0;
      } else {
        this.contentParamsOther.queryData.contentType = "PICTURE,FILE";
        this.contentParamsOther.currentPage = 0;
      }
      // 标志的是为视频还是文章tab选中状态
      this.tabContentValue = tempMain;
      this.findId(tempInfo.value, tempInfo.e);
    }

    this.initFF();
    localStorage.removeItem("keyWord");
    localStorage.removeItem("firstOtherPlateInfo");
    localStorage.removeItem("videoInfo");
    localStorage.removeItem("firstPlateInfo");
    localStorage.removeItem("tabPage"); //清空点击的tab值，
    localStorage.removeItem("videoInfos");
    localStorage.setItem("colu", "推荐");
    // 判断是否从弹框的我的收藏中进去的，是的话展示收藏
    let val = this.$route.params.val;
    if (val === 1) {
      this.tabValue = 0;
    }
    // 再次返回页面，tab定位到之前点击的地方
    // let tempValue = sessionStorage.getItem('   ') ? JSON.parse(sessionStorage.getItem('tabValue')) : 0
    // this.tabValue = tempValue
  },
  beforeMount() {},
  mounted() {
    this.limiNum = document
      .querySelector(".van-tabs-warp")
      .getBoundingClientRect().top;
    this.OriginskuWarpMarginTopNmu = window
      .getComputedStyle(document.querySelector(".conent_detail"))
      .getPropertyValue("margin-top");
    this.skuWarpMarginTopNmu =
      document.querySelector(".van-tabs-warp").getBoundingClientRect().height +
      document.querySelector(".content_tab").getBoundingClientRect().height;

    window.addEventListener("scroll", this.initFixedHeight);
    this.isFirstLogin = JSON.parse(localStorage.getItem("isFirstLoginIndex"));
    if (this.isFirstLogin) {
      this.$refs.pop.show();
      localStorage.setItem("isFirstLoginIndex", JSON.stringify(false));
    }
  },
  activated() {},
  deactivated() {},
  beforeRouteLeave(to, from, next) {
    this.$bus.$off("toConcerned");
    next();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.initFixedHeight, false);
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
$tabCenter: "../../assets/images/parent-course/tab-center.png";
$tabCommon: "../../assets/images/parent-course/tab-common.png";
$plane: "../../assets/images/parent-course/plane.png";
$active: "../../assets/images/parent-course/active.png";

.course_container {
  font-weight: 500;
  // margin-top: 100px;
  .tab_wrap {
    // margin-top: -120px;
    // display: flex;
    // justify-content: center;
    padding: 12px 20px 8px 20px;
    .change-child {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      .name-drp {
        color: #333333;
      }
      .name-warp {
        display: flex;
        align-items: center;
        .name {
          color: #00aadf;
          line-height: 22px;
        }
        .right-arrow {
          width: 22px;
          height: 22px;
        }
      }
    }
    .change-tab {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      .health-education {
        width: 146px;
        height: 70px;
        background: url(('../index/images/health-education.png')) no-repeat;
        background-size: 100% 100%;
        box-shadow: 0px 4px 12px 0px rgba(24, 190, 184, 0.2);
        font-size: 14px;
        color: #333333;
        line-height: 70px;
        padding-left: 20px;
      }
      .health-education-active {
        width: 172px;
        height: 82px;
        background: url("../index/images/health-education-active.png") no-repeat;
        background-size: 100% 100%;
        box-shadow: 0px 4px 12px 0px rgba(24, 190, 184, 0.2);
        font-size: 16px;

        line-height: 82px;
        padding-left: 20px;
        span {
          color: #ffffff;
        }
      }
      .assess {
        width: 146px;
        height: 70px;
        background: url("../index/images/assess.png") no-repeat;
        background-size: 100% 100%;
        box-shadow: 0px 4px 12px 0px rgba(24, 190, 184, 0.2);
        font-size: 14px;
        line-height: 70px;
        padding-left: 20px;
        span {
          color: #333333;
        }
      }
      .assess-active {
        width: 176px;
        height: 82px;
        background: url("../index/images/assess-active.png") no-repeat;
        background-size: 100% 100%;
        font-size: 16px;
        color: #ffffff;
        line-height: 82px;
      }
    }
    .ul_wrap {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      width: calc(100% - 26px);
      height: 86px;
      // border: 1px solid red;

      .commonli {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 95px;
        height: 75px;
        background: url($tabCommon) no-repeat;
        background-size: contain;
        .pop {
          position: absolute;
          right: 0;
          top: 0;
          width: 25px;
          height: 25px;
          background-color: #ff5656;
          border-radius: 50%;
          transform: translate(10px, -10px);
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            color: #fff;
            font-size: 12px;
          }
        }
        a {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        // border: 1px solid blue;
        &.active {
          width: 120px;
          height: 86px;
          background: url($tabCenter) no-repeat;
          background-size: cover;
          .img1 {
            width: 59px;
            height: 52px;
            img {
              display: block;
              width: 100%;
            }
          }
          .img2 {
            width: 65px;
            height: 18px;
            img {
              display: block;
              width: 100%;
            }
          }
        }
        .img1 {
          width: 67px;
          height: 46px;
          img {
            display: block;
            width: 100%;
          }
        }
        .img2 {
          width: 58px;
          height: 23px;
          img {
            display: block;
            width: 100%;
          }
        }
        &.commonli-2,
        &.commonli-3 {
          position: relative;
          .range_area {
            position: absolute;
            right: 0px;
            top: 0px;
            width: 28px;
            height: 28px;
            // border: 1px solid red;
          }
          .question {
            position: absolute;
            top: 6px;
            width: 10px;
            height: 10px;
            img {
              display: block;
              width: 100%;
            }
          }
          .question1 {
            right: 6px;
          }
          .question2 {
            right: 3px;
          }
          .child {
            position: absolute;
            width: 26px;
            height: 18px;
            img {
              width: 100%;
              display: block;
            }
            right: 1%;
            top: 35%;
          }
        }
      }
    }
  }

  .van-tabs-warp {
    padding: 4px 0 0px 0;
    background: url("../../assets/images/index/header-bg.png") no-repeat;
    background-size: 100%;
    background-position-y: -260px;
    background-color: #f5f7fa;
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    &.is_fixed {
      position: fixed;
      z-index: 9999;
      top: 0px;
      width: 100%;
    }
    .van-tabs {
      width: 345px;
    }
    .moreBox {
      text-align: center;
      margin-left: 4px;
      .more {
        width: 20px;
        height: 20px;
      }
      p {
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #10d8e2;
      }
    }

    .van-tabs {
      ::v-deep .van-tabs__wrap {
        overflow: visible;
      }
      ::v-deep .van-tabs__nav {
        background-color: transparent;
        .van-tab {
          font-size: 16px;
          padding: 0;
          margin: 0 8px;
          span {
            padding: 0 20px;
            background: #ffffff;
            box-shadow: 0px 2px 8px 0px rgba(80, 226, 208, 0.2);
            min-width: 72px;
            line-height: 40px;
            border-radius: 20px;
            text-align: center;
            color: #333333;
          }
        }
        .van-tab--active {
          span {
            background: linear-gradient(180deg, #17e1eb 0%, #00cdd7 100%);
            color: #ffffff;
            font-weight: 500;
          }
        }
        .van-tabs__line {
          display: none;
        }
      }
    }
  }

  .content_area {
    .content_tab {
      padding-bottom: 10px;
      &.is_fixed_2 {
        position: fixed;
        top: 48px;
        width: 100%;
        background: url("../../assets/images/index/header-bg.png") no-repeat;
        background-size: 100%;
        background-position-y: -313px;
        background-color: #f5f7fa;
        z-index: 99;
      }
      .van-tabs {
        ::v-deep .van-tabs__wrap {
          padding-left: 20px;
          height: 36px;
          .van-tabs__line {
            background-color: #11d9e3;
            border-radius: 2px;
            width: 20px !important;
            height: 4px;
          }
          .van-tabs__nav {
            .van-tab {
              flex: initial;
              margin-right: 20px;
            }
          }
        }

        ::v-deep .van-tab__text {
          font-size: 16px;
        }
        ::v-deep .van-tab--active {
          font-weight: 500;
        }
      }
    }
    .tag-tab-class {
      ::v-deep .van-tabs__wrap {
        padding-left: 0px !important;
        .van-tabs__nav {
          .van-tab {
            flex: none !important;
            margin-right: 0px !important;
          }
        }
      }
    }
    .conent_detail {
      display: flex;
      flex-direction: column;
      align-items: center;

      &.fix_margin {
        width: 100%;
        background-color: #fff;
        margin-top: 138px;
      }
    }
  }
  .nodata {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .marginStyle {
    margin-top: 50px;
  }
}

.namelist-warp {
  margin: 85px auto 0 auto;
  width: 220px;
  padding: 16px 20px;
  background-color: #fff;

  border-radius: 0px 12px 12px 12px;
  font-size: 16px;

  font-weight: 500;
  text-align: center;
  .namelist-item {
    margin-top: 25px;
    color: #626a6b;
    &:nth-of-type(1) {
      margin-top: 22px;
    }
  }
  .namelist-item-active {
    color: #00aadf;
  }
  .van-button {
    margin-top: 20px;
    width: 100%;
    height: 40px;
    color: #0ed7e1 !important;
    font-size: 16px;
    border: none;
  }
}
.van-overlay {
  background: rgba(0, 0, 0, 0.4);
}
.van-list {
  ::v-deep .van-list__finished-text {
    line-height: 69px;
  }
  ::v-deep .van-list__loading {
    line-height: 69px;
  }
}
.modalBox {
  z-index: 10000 !important;
}
.topModal {
  .topModal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px 14px 20px;
    p {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #2e4344;
    }
    img {
      width: 12px;
      height: 12px;
    }
  }
  .topModal-content {
    padding-left: 12px;
    display: flex;
    flex-wrap: wrap;
    .topModal-content-title {
      height: 40px;
      background: rgba(14, 215, 225, 0.1);
      box-shadow: 0px 4px 8px 0px rgba(80, 226, 208, 0.3);
      border-radius: 22px;
      padding: 0 20px;
      line-height: 40px;
      margin-right: 12px;
      margin-bottom: 21px;
      color: #2e4344;
      font-size: 16px;
    }
    .chooseActive {
      background: linear-gradient(180deg, #17e1eb 0%, #0cd3dd 100%);
      color: #fff;
    }
  }
}
</style>
